class ChannelSelectorManager {
    constructor(config = {}) {
        var _a, _b, _c;
        this.config = {
            cookieName: (_a = config.cookieName) !== null && _a !== void 0 ? _a : 'insight-user-selected-channel',
            countryCookieName: (_b = config.countryCookieName) !== null && _b !== void 0 ? _b : 'insight-aus-country-page',
            debug: (_c = config.debug) !== null && _c !== void 0 ? _c : false
        };
        this.log('ChannelSelectorManager initialized');
    }
    getCookie(name) {
        try {
            if (!document.cookie)
                return null;
            const cookies = document.cookie.split(';');
            for (const cookie of cookies) {
                const trimmedCookie = cookie.trim();
                if (trimmedCookie.startsWith(`${name}=`)) {
                    return decodeURIComponent(trimmedCookie.substring(name.length + 1));
                }
            }
            return null;
        }
        catch (error) {
            console.error(`Error getting cookie ${name}:`, error);
            return null;
        }
    }
    setCookie(name, value, options = {}) {
        try {
            const defaultOptions = {
                path: '/',
                expires: 90,
                duration: 'days'
            };
            const opts = Object.assign(Object.assign({}, defaultOptions), options);
            let expiresString = '';
            if (opts.expires && opts.expires > 0) {
                const date = new Date();
                switch (opts.duration) {
                    case 'seconds':
                        date.setTime(date.getTime() + opts.expires * 1000);
                        break;
                    case 'days':
                        date.setDate(date.getDate() + opts.expires);
                        break;
                    case 'months':
                        date.setMonth(date.getMonth() + opts.expires);
                        break;
                    case 'years':
                        date.setFullYear(date.getFullYear() + opts.expires);
                        break;
                }
                expiresString = `; expires=${date.toUTCString()}`;
            }
            document.cookie = `${name}=${encodeURIComponent(value || '')}${expiresString}; path=${opts.path}`;
            this.log('Cookie set:', name, '=', value);
        }
        catch (error) {
            console.error(`Error setting cookie ${name}:`, error);
        }
    }
    getChannelIdFromCookie(cookieValue) {
        if (!cookieValue)
            return 0;
        try {
            const legalCookieCountry = this.getCookie(this.config.countryCookieName) || '';
            const channels = cookieValue.split('|');
            for (const channel of channels) {
                const [country, channelId] = channel.split(',');
                if (country === legalCookieCountry || country === '' || legalCookieCountry === '') {
                    return parseInt(channelId, 10) || 0;
                }
            }
            return 0;
        }
        catch (error) {
            console.error('Error extracting channel ID from cookie:', error);
            return 0;
        }
    }
    saveChannelSelection(channelGuid) {
        if (!channelGuid)
            return;
        try {
            const existingChannels = this.getCookie(this.config.cookieName) || "";
            let newSelectedChannels = "";
            let channelExists = false;
            this.log('Saving channel selection:', channelGuid);
            this.log('Existing cookie value:', existingChannels);
            if (existingChannels) {
                const channels = existingChannels.split("|");
                const [newCountry] = channelGuid.split(",");
                for (let i = 0; i < channels.length; i++) {
                    const [existingCountry] = channels[i].split(",");
                    if (existingCountry === newCountry) {
                        channelExists = true;
                        newSelectedChannels = existingChannels.replace(channels[i], channelGuid);
                        this.log('Updating existing country:', newCountry);
                        break;
                    }
                }
                if (!channelExists) {
                    newSelectedChannels = `${existingChannels}|${channelGuid}`;
                    this.log('Appending new country/channel pair');
                }
            }
            else {
                newSelectedChannels = channelGuid;
                this.log('Setting first channel selection');
            }
            this.setCookie(this.config.cookieName, newSelectedChannels, {
                path: '/',
                expires: 90,
                duration: 'days'
            });
            this.log('✅ Channel selection saved. Final cookie value:', newSelectedChannels);
        }
        catch (error) {
            console.error('Error saving channel selection:', error);
        }
    }
    getSelectedChannel() {
        return this.getCookie(this.config.cookieName);
    }
    getSelectedChannelId() {
        const selectedChannel = this.getSelectedChannel();
        if (!selectedChannel)
            return 0;
        return this.getChannelIdFromCookie(selectedChannel);
    }
    updateChannelDisplay(buttonSelector, textSelector, linksSelector) {
        var _a;
        try {
            const selectedChannel = this.getSelectedChannel();
            const textElements = textSelector
                ? document.querySelectorAll(textSelector)
                : document.querySelectorAll(buttonSelector);
            this.log('Updating channel display:', {
                selectedChannel,
                textElementsFound: textElements.length
            });
            if (!selectedChannel || textElements.length === 0) {
                this.log('Cannot update display - missing channel cookie or elements');
                return false;
            }
            const channelId = this.getChannelIdFromCookie(selectedChannel);
            this.log('Extracted channel ID:', channelId);
            if (channelId > 0) {
                const channelLink = document.querySelector(`${linksSelector} a[data-channelguid$="${channelId}"]`);
                this.log('Channel link found:', !!channelLink);
                if (channelLink) {
                    const channelName = (_a = channelLink.textContent) === null || _a === void 0 ? void 0 : _a.trim();
                    this.log('Channel name:', channelName);
                    if (channelName) {
                        let updateCount = 0;
                        textElements.forEach(element => {
                            element.textContent = channelName;
                            updateCount++;
                        });
                        this.log(`✅ Channel display updated to: ${channelName} (${updateCount} instances)`);
                        return true;
                    }
                }
            }
            return false;
        }
        catch (error) {
            console.error('Error updating channel display:', error);
            return false;
        }
    }
    setupChannelClickHandlers(linksSelector) {
        try {
            const channelLinks = document.querySelectorAll(`${linksSelector} a[data-channelguid]:not([data-channel-initialized])`);
            this.log('Setting up channel click handlers for', channelLinks.length, 'links');
            channelLinks.forEach((link) => {
                link.setAttribute('data-channel-initialized', 'true');
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    const channelGuid = link.getAttribute('data-channelguid');
                    this.log('Channel clicked:', channelGuid);
                    if (channelGuid) {
                        this.saveChannelSelection(channelGuid);
                        const href = link.href;
                        if (href) {
                            window.location.href = href;
                        }
                    }
                });
            });
        }
        catch (error) {
            console.error('Error setting up channel click handlers:', error);
        }
    }
    log(...args) {
        if (this.config.debug) {
            console.log('[ChannelSelector]', ...args);
        }
    }
}
let channelSelectorInstance = null;
export const channelSelector = {
    getInstance(config) {
        if (!channelSelectorInstance) {
            channelSelectorInstance = new ChannelSelectorManager(config);
        }
        return channelSelectorInstance;
    },
    init(buttonSelector, textSelector, linksSelector) {
        const manager = this.getInstance({ debug: true });
        manager.setupChannelClickHandlers(linksSelector);
        manager.updateChannelDisplay(buttonSelector, textSelector, linksSelector);
    }
};
if (typeof window !== 'undefined') {
    window.channelSelector = channelSelector;
}
